/* eslint-disable no-restricted-imports */
import { useCallback, useState } from 'react';
import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import useSetInGameCurrency from '~/client/hooks/feature/inGameCurrency/useSetInGameCurrency';
import usePreferredInGameCurrency from './usePreferredInGameCurrency';
import sendEventToUmami from '@/client/helpers/trackEvent/sendEventToUmami';
import getUnitName from '@/server/graphql/getCurrencyConfig/helpers/getUnitName';

const useSelectedCurrency = (
  isUbtcEnabled: boolean,
  initialInGameCurrency?: Unit,
  walletCurrency?: CashierCurrency,
) => {
  const [isDisabled, setDisabled] = useState(false);
  const { profileCurrency, setCurrency } = usePreferredInGameCurrency(
    initialInGameCurrency,
  );
  const { inGameCurrency } = useGameContext();
  const { setInGameCurrency } = useSetInGameCurrency();

  const handleChange = useCallback(
    (selectedCurrency: string | null) => {
      sendEventToUmami(
        {
          newInGameCurrency: selectedCurrency,
          walletCurrency: inGameCurrency,
        },
        'changeInGameCurrency',
      );
      const targetCurrency = walletCurrency
        ? getUnitName(walletCurrency, isUbtcEnabled)
        : undefined;
      setInGameCurrency(selectedCurrency ?? targetCurrency);
      setCurrency(selectedCurrency ?? targetCurrency);
      setDisabled(true);
      setTimeout(() => setDisabled(false), 7000);
    },
    [
      inGameCurrency,
      setCurrency,
      setInGameCurrency,
      walletCurrency,
      isUbtcEnabled,
    ],
  );

  return {
    isDisabled,
    handleChange,
    selectedCurrency: profileCurrency,
  };
};

export default useSelectedCurrency;
